import React, { useEffect, useState } from "react";
import type { NotificationItem } from "./notificationData";

import "./Notification.scss";
import {
  gxDateFormat,
  gxDateTimeFormat,
} from "@/app/utils/helpers/gxDateTimeFormat";
import { gxRtpViewIndividualApi } from "@/app/apiConfig/services/paymentsAbstractApiLayer";
import type {
  GxRtpViewIndividualResponse,
  RtpViewIndividualPayload,
} from "@/app/types/payments";
import StatusBadge from "@/app/components/common/badge/StatusBadge";
import { useT } from "@/app/hooks/useT";
import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";
import { MaskedAccountField } from "@/app/utils/MaskedAccountField";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
import { ICON_BASE_PATH } from "@/app/utils/config";

interface NotificationDetailsProps {
  item: NotificationItem | null;
}
export const NotificationDetails = ({ item }: NotificationDetailsProps) => {
  const t = useT();
  const [rtpRequestDetails, setRtpRequestDetails] =
    useState<GxRtpViewIndividualResponse | null>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const categorySlug = item?.category.toLowerCase().replace(/\s+/g, "-");

  console.log("item", item);

  const rtpRequestView = async () => {
    try {
      const gxChnNo = item?.description?.split("Reference: ")[1];

      if (!item?.actionId || !gxChnNo) return;
      setLoader(true);
      const payload: RtpViewIndividualPayload = {
        rtpTransId: item?.actionId,
        gxChnNo: gxChnNo,
      };

      const response = await gxRtpViewIndividualApi(payload);
      if (response?.data) {
        setRtpRequestDetails(response?.data);
      }
    } catch (err) {
      console.error("Error in rtpRequestView::", err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (item?.rtpActionFlag === "Y") {
      rtpRequestView();
    }
  }, [item]);

  useEffect(() => {
    return () => {
      setRtpRequestDetails(null);
    };
  }, []);

  return (
    <div className="gx-notification-details">
      <div className="gx-notification-details-title-container">
        <span
          className={`notification-category gx-p14-sb notification-category--${categorySlug}`}
        >
          {item?.category}
        </span>
        <span className="notification-time gx-p12-m">
          {gxDateTimeFormat(item?.time)}
        </span>
      </div>
      <hr />
      {item?.rtpActionFlag === "Y" && (
        <div>
          <div className="gx-row">
            <span className="gx-t-lable">{t("status")}</span>
            <span className="gx-t-value">
              <StatusBadge module="text" statusCode={"PENDING_RESPONSE"} />
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable">{"Requested By"}</span>
            <span className="gx-t-value">
              {rtpRequestDetails?.initiatedBy || "---"}
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable">{"Amount"}</span>
            <span className="gx-t-value">
              {rtpRequestDetails?.depositAmount &&
              rtpRequestDetails?.depositCurrency
                ? gxCurrencyFormat(
                    rtpRequestDetails?.depositAmount,
                    rtpRequestDetails?.depositCurrency,
                  ).formatted
                : "---"}
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable">{"Requested Payment Date"}</span>
            <span className="gx-t-value">
              {rtpRequestDetails?.collectionDate
                ? gxDateFormat(rtpRequestDetails?.collectionDate)
                : "---"}
            </span>
          </div>

          <MaskedAccountField
            label={"Deposit To"}
            accountNumber={rtpRequestDetails?.depositAccountNo || "---"}
          />
          <div className="gx-row">
            <span className="gx-t-lable">{"Reference Note"}</span>
            <span className="gx-t-value">
              {rtpRequestDetails?.requestNotes || "---"}
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable">{"Requested On"}</span>
            <span className="gx-t-value">
              {rtpRequestDetails?.crtdDt
                ? gxDateTimeFormat(rtpRequestDetails?.crtdDt)
                : "---"}
            </span>
          </div>
          <div className="gx-notification-details-info-card">
            <img
              src={ICON_BASE_PATH + "info_icon_sky_blue.svg"}
              alt="rtp_request_info"
            />
            <span className="gx-p12-r">
              {
                "Review this payment request carefully. If you accept, GrowX will prepare a pre-filled Domestic Payment for your review and submission. No payment will be processed until you submit the payment and it completes the required approval workflow."
              }
            </span>
          </div>
        </div>
      )}
      {loader && <SubmitLoading />}
    </div>
  );
};
